var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconCheck1Bold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.37.29a1.49 1.49 0 0 0-2.09.34L7.25 20.2l-4.69-4.69a1.5 1.5 0 0 0-2.12 2.12l5.93 5.94a1.53 1.53 0 0 0 2.28-.19l15.07-21a1.49 1.49 0 0 0-.35-2.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconCheck1Bold);
export default __webpack_public_path__ + "static/media/streamline-icon-check-1-bold.477fe35e.svg";
export { ForwardRef as ReactComponent };